import { RootState } from 'app/store';

export const selectRecruitmentOverviewCities = (state: RootState) =>
  state.reports.recruitmentOverviewCities;

export const selectRecruitmentOverviewStatistics = (state: RootState) =>
  state.reports.recruitmentOverviewStatistics;

export const selectRecruitmentOverviewStatisticsError = (state: RootState) =>
  state.reports.recruitmentOverviewStatisticsError;

export const selectRecruitmentOverviewJobs = (state: RootState) =>
  state.reports.recruitmentOverviewJobs;

export const selectRecruitmentOverviewClosedHires = (state: RootState) =>
  state.reports.recruitmentOverviewClosedHires;

export const selectRecruitmentOverviewClosedHiresRequestStatus = (
  state: RootState
) => state.reports.recruitmentOverviewClosedHiresRequestStatus;

export const selectReportsDetails = (state: RootState) => {
  return state.reports;
};
